<footer class="it-footer">
    <div class="it-footer-main">
        <div class="container-footer px-4 py-0">
            <section class="pt-3 px-2">

                @if (!isGroupPaymentPage) {

                    <div id="b2c-footer-logos">
                        <img loading="lazy" class="footerImg" role="img"
                            [src]="assetsContextRoot + 'assets/images/EN_Funded_by_the_European_Union.svg'"
                            [alt]="'Acc_img_alt.LOGO_UE' | translate" width="200px" height="72px">

                        <a [href]="footerConst.LINK_MIN_CULTURA" title="Collegamento a sito esterno" target="_blank"
                            aria-label="MIC Ministero della Cultura - Collegamento a sito esterno - Apertura in nuova scheda"
                            rel="noopener">
                            <img loading="lazy" class="footerImg"
                                [src]="assetsContextRoot + 'assets/images/MiC_logo_esteso_Negativo.svg'"
                                [alt]="'Acc_img_alt.MINISTRY_OF_CULTURE' | translate" width="200px" height="72px">
                        </a>

                        <img loading="lazy" class="footerImg" role="img"
                            [src]="assetsContextRoot + 'assets/images/logo-italia-domani.svg'"
                            alt="Logo PNNR" width="200px" height="72px">

                    </div>

                } @else {

                    <div id="group-payment-footer-logos">
                        <img loading="lazy" class="footerImg" role="img"
                            [src]="assetsContextRoot + 'assets/images/coesioneItalia.webp'"
                            [alt]="'Acc_img_alt.LOGO_COESIONE_UNITA' | translate" width="180px" height="72px">

                        <img loading="lazy" class="footerImg" role="img"
                            [src]="assetsContextRoot + 'assets/images/cofounded_by_EU.webp'"
                            [alt]="'Acc_img_alt.COFOUNDED_BY_UE' | translate" width="180px" height="72px">

                        <img loading="lazy" class="footerImg" role="img"
                            [src]="assetsContextRoot + 'assets/images/logo_repubblica_color.svg'"
                            [alt]="'Acc_img_alt.LOGO_REP_ITA' | translate" width="180px" height="72px">

                        <a [href]="footerConst.LINK_MIN_CULTURA" title="Collegamento a sito esterno" target="_blank"
                           aria-label="MIC Ministero della Cultura - Collegamento a sito esterno - Apertura in nuova scheda"
                           rel="noopener">
                            <img loading="eager" class="footerImg"
                                [src]="assetsContextRoot + 'assets/images/MiC_logo_esteso_Negativo.svg'"
                                [alt]="'Acc_img_alt.MINISTRY_OF_CULTURE' | translate" width="180px" height="72px">
                        </a>
                    </div>

                }

            </section>
            <section class="mt-4 border-white border-top px-0 pb-4">
                <div class="row pt-4">
                   <div class="col-md-4 pb-md-2">
                        <h4 class="h5">{{ 'Footer.CONTACTS' | translate }}</h4>
                   </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <h5 class="h6 sub-title-footer mb-0"> {{ footerConst.DIREZIONE }} </h5>
                        <ul class="footer-list list-unstyled">
                            <li>
                                <span> {{ footerConst.ADDRESS }} </span>
                            </li>
                            <li>
                                <span> {{ footerConst.POSTAL_CODE }} - {{ footerConst.CITY }} </span>
                            </li>
                        </ul>
                    </div>
                    <div class="col-md-4 pt-md-0 p-smn" >
                        <h5 class="h6 sub-title-footer mb-0">{{ 'Footer.HELPDESK' | translate }}</h5>
                        <ul class="footer-list list-unstyled">
                            <li>
                                <span> {{ footerConst.MAIL }} </span>
                            </li>
                            <li>
                                <span> {{ footerConst.TEL }} </span>
                            </li>
                            <li>
                                <span>{{ 'Footer.OPEN_HOUR' | translate }}</span>
                            </li>
                        </ul>
                    </div>
                    <div class="col-md-4 pt-md-0 p-smn">
                        <h5 class="h6 sub-title-footer">{{ 'Footer.FOLLOW_US' | translate }}</h5>
                        <ul class="list-inline align-text-start social">
                            <li class="list-inline-item">
                                <a [href]="footerConst.LINK_META" target="_blank" class="text-white text-decoration-none" rel="noopener"
                                    title="Collegamento a sito esterno" aria-label="Facebook Ministero della Cultura - Apertura in nuova scheda">
                                    <fa-icon class="fa-lg" [icon]="faFacebook"></fa-icon>
                                </a>
                            </li>
                            <li class="list-inline-item">
                                <a [href]="footerConst.LINK_X" target="_blank" class="text-white text-decoration-none" rel="noopener"
                                    title="Collegamento a sito esterno" aria-label="Twitter Ministero della Cultura - Apertura in nuova scheda">
                                    <fa-icon class="fa-lg" [icon]="faTwitter"></fa-icon>
                                </a>
                            </li>
                            <li class="list-inline-item">
                                <a [href]="footerConst.LINK_INSTA" target="_blank" class="text-white text-decoration-none" rel="noopener"
                                    title="Collegamento a sito esterno" aria-label="Instagram Ministero della Cultura - Apertura in nuova scheda">
                                    <fa-icon class="fa-lg" [icon]="faInstagram"></fa-icon>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </section>
        </div>
    </div>
    <div class="it-footer-small-prints clearfix">
        <div class="container-footer">
          <ul class="it-footer-small-prints-list list-inline mb-0 d-flex flex-column-reverse flex-md-row justify-content-md-between align-items-center">
            <li class="list-inline-item">
              <small class="mb-0 small font-weight-light"> {{ footerConst.COPYRIGHT }}, {{ footerConst.DIREZIONE }} </small>
            </li>
            <li class="list-inline-item">
              <a class="link-footer" target="_blank" href="https://form.agid.gov.it/m_bac/musei_italiani-3/dichiarazione" title="Accessibilita"> {{'Footer.ACCESSIBILITY' | translate}} </a>
            </li>
            <li class="list-inline-item">
              <a class="link-footer" target="_blank" href="https://museiitaliani.it/privacy-policy" title="Note Legali"> {{footerConst.PRI_POLICY }}</a>
            </li>
          </ul>
        </div>
    </div>
</footer>


